<template>
  <PrimeSlider
    v-bind="$props"
    v-model="modelValue"
    :pt="passThrough"
    @update:modelValue="$emit('update:modelValue', $event)"
    @change="$emit('change', $event)"
    @slideend="$emit('slideend', $event)"
  />
</template>

<script setup lang="ts">
import { usePassThrough } from 'primevue/passthrough';
import PrimeSlider from 'primevue/slider';
import { PassThroughMeridiaSlider } from './MeridiaSlider';

const modelValue = defineModel<number | number[]>();

const props = defineProps<{
  min?: number;
  max?: number;
  orientation?: 'horizontal' | 'vertical';
  step?: number;
  range?: boolean;
  disabled?: boolean;
  tabindex?: number;
  ariaLabel?: string;
  ariaLabelledby?: string;
  unstyled?: boolean;
  pt?: PassThroughMeridiaSlider;
  ptOptions?: any;
}>();

defineEmits<{
  'update:modelValue': [value: number | number[]];
  'change': [value: number | number[]];
  'slideend': [event: Event];
}>();

const passThrough = usePassThrough(props.pt, {} as PassThroughMeridiaSlider, { mergeSections: true, mergeProps: true }) as PassThroughMeridiaSlider;
</script>